<template>
  <div @click="routeToBrand(data.id)" class="car-card">
    <ImgComponent :head_img="data.img" class="car-card__img" />
    <span class="car-card__text"
      >{{ data.products_count }}
      <span class="car-card__title">{{
        data.products_count | plural_word("товар", "товара", "товаров")
      }}</span></span
    >
  </div>
</template>

<script>
import ImgComponent from "components/ImgComponent.vue";
export default {
  name: "CarCard",
  props: {
    data: {
      type: Object,
    },
  },
  methods: {
    routeToBrand(id) {
      this.$router.push({ name: "brand", params: { id: id } });
    },
  },
  components: { ImgComponent },
};
</script>

<style lang="stylus">
.car-card {
  display flex
  align-items: center;
  justify-content: center;
  flex-direction column
  gap 10px
  padding 30px 57px
  border-radius var(--small-radius)
  background var(--white)
  cursor: pointer;

  +below(1024px) {
    padding 27px 29px
  }

  &__img {
    //max-width 150px
    max-height 150px
    object-fit none

    +below(1024px) {
      //max-width 60px
      max-height: 60px;
    }
  }

  &__text {
    font-weight: 500;
    font-size: 1.25em;
    line-height: 28px;
    text-transform: uppercase;
    color: var(--black);

    +below(1024px) {
      font-size: 1em;
      line-height: 19px;
    }
  }

  &__title {
    font-weight 400
  }
}
</style>
